import React, { Component } from 'react';  // eslint-disable-line
import Profile from './Profile';
import More from '../More';
import Messages from './Messages';
import Checkin from './Checkin';
class PreviewModuleTileMenuIcon extends Component {
    render() {
        let body;
        switch (this.props.moduleType) {
            case 'more': {
                body = <More />;
                break;
            }
            case 'messages': {
                body = <Messages activeColor={this.props.actionColor} />;
                break;
            }
            case 'profile': {
                body = (<Profile activeColor={this.props.actionColor} />);
                break;
            }
            case 'checkin': {
                body = <Checkin activeColor={this.props.actionColor} />;
                break;
            }
            default: {
                body = (<Profile activeColor={this.props.actionColor} />);
                break;
            }
        }

        return body;
    }
}

export default PreviewModuleTileMenuIcon;
